<template>
  <VModalWidget :dismiss="dismiss" :submit="doSubmit" :submitting="submitting">
    <template slot="title">{{ $t('title') }}</template>

    <template slot="content">
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <v-form>
        <LanguageField v-model="form.language" :errors="languageErrors" />
        <TimezoneField v-model="form.timezone" :errors="timezoneErrors" />
      </v-form>
    </template>
  </VModalWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { BaseForm, FormErrors, VModalWidget, LanguageField, TimezoneField } from '@argon/app/components'
import { Modal } from '@argon/app/mixins'
import { diffObjects } from '@argon/app/helpers'
import { required } from 'vuelidate/lib/validators'
import { NAMESPACE } from '../store'
export default {
  name: 'OrganizationPreferencesModal',
  extends: BaseForm,
  mixins: [Modal],
  components: {
    FormErrors,
    VModalWidget,
    LanguageField,
    TimezoneField
  },
  validations: {
    form: {
      language: { required },
      timezone: { required }
    }
  },
  data: () => ({
    returnPath: { name: 'organizationSettings' },
    form: {
      language: '',
      timezone: ''
    },
    submitting: false
  }),
  computed: {
    ...mapState(NAMESPACE, ['settings', 'currentOrg']),
    languageErrors() {
      const errors = []
      if (!this.$v.form.language.$dirty) return errors
      !this.$v.form.language.required && errors.push(this.$t('required'))
      this.getServerErrors('language', errors)
      return errors
    },
    timezoneErrors() {
      const errors = []
      if (!this.$v.form.timezone.$dirty) return errors
      !this.$v.form.timezone.required && errors.push(this.$t('required'))
      this.getServerErrors('timezone', errors)
      return errors
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['patchSettings']),
    doSubmit() {
      this.resetServerErrors()
      if (this.$v.form.$invalid) {
        return this.$v.form.$touch()
      }
      this.submitting = true
      let data = diffObjects(this.form, this.settings)
      this.patchSettings({ orgId: this.currentOrg.id, data })
        .then((resp) => {
          this.dismiss()
        })
        .catch(this.setServerErrors)
        .finally(() => {
          this.submitting = false
        })
    }
  },
  created() {
    if (this.settings) {
      this.form = { ...this.settings }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "invalid": "@:labels.invalid",
    "required": "@:labels.required",
    "save": "@:labels.save",
    "title": "Preferences"
  },
  "fr": {
    "invalid": "@:labels.invalid",
    "required": "@:labels.required",
    "save": "@:labels.save",
    "title": "Préférences"
  }
}
</i18n>
